<template>
  <div class="flex items-start gap-3 px-8 pt-8 pb-0 w-full min-w-0">
    <div
      v-if="headerIcon"
      class="flex flex-shrink-0 items-center justify-center w-10 h-10 rounded-full bg-slate-75 dark:bg-slate-700"
    >
      <fluent-icon
        :icon="headerIcon"
        size="20"
        class="text-slate-600 dark:text-slate-200"
      />
    </div>
    <img v-else-if="headerImage" :src="headerImage" alt="No image" />
    <div class="flex flex-col items-start flex-1 min-w-0">
      <h2
        ref="modalHeaderTitle"
        class="text-base font-semibold leading-6 text-slate-800 dark:text-slate-50"
      >
        {{ headerTitle }}
      </h2>
      <p
        v-if="headerContent"
        ref="modalHeaderContent"
        class="w-full mt-2 text-sm leading-5 break-words text-slate-600 dark:text-slate-300"
      >
        {{ headerContent }}
        <span
          v-if="headerContentValue"
          class="text-sm font-semibold text-slate-600 dark:text-slate-300"
        >
          {{ headerContentValue }}
        </span>
      </p>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    headerTitle: {
      type: String,
      default: '',
    },
    headerContent: {
      type: String,
      default: '',
    },
    headerContentValue: {
      type: String,
      default: '',
    },
    headerImage: {
      type: String,
      default: '',
    },
    headerIcon: {
      type: String,
      default: '',
    },
  },
};
</script>
